// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/typedef */
import { SylPlugin } from '@syllepsis/adapter';
import { VideoController } from './controller';
import { VideoView } from './view';

export class VideoPlugin extends SylPlugin {
  public name = 'video';

  public Controller = VideoController;

  public Schema = VideoView;
}
